import React from "react";
import $ from "jquery";
import logo3 from "../img/logo.png";

class Navbar extends React.Component {
  constructor() {
    super();
    this.state = {
      logo: logo3,
    };
  }

  componentDidMount() {
    const nav = $("nav");
    let navHeight = nav.outerHeight();

    $(".navbar-toggler").on("click", function () {
      if (!$("#mainNav").hasClass("navbar-reduce")) {
        $("#mainNav").addClass("navbar-reduce");
      }
    });

    $("body").scrollspy({
      target: "#mainNav",
      offset: navHeight,
    });

    $(".js-scroll").on("click", function () {
      $(".navbar-collapse").collapse("hide");
    });

    window.addEventListener("scroll", () => {
      if (window.pageYOffset > 50) {
        document
          .querySelector(".navbar-expand-md")
          .classList.add("navbar-reduce");
        document
          .querySelector(".navbar-expand-md")
          .classList.remove("navbar-trans");
        this.setState({ logo: logo3 });
      } else {
        document
          .querySelector(".navbar-expand-md")
          .classList.add("navbar-trans");
        document
          .querySelector(".navbar-expand-md")
          .classList.remove("navbar-reduce");
        this.setState({ logo: logo3 });
      }
    });

    $('a.js-scroll[href*="#"]:not([href="#"])').on("click", function () {
      if (
        window.location.pathname.replace(/^\//, "") ===
          this.pathname.replace(/^\//, "") &&
        window.location.hostname === this.hostname
      ) {
        var target = $(this.hash);
        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]");
        if (target.length) {
          $("html, body").animate(
            {
              scrollTop: target.offset().top - navHeight + 5,
            },
            1000,
            "easeInExpo"
          );
          return false;
        }
      }
    });

    $(".js-scroll").on("click", function () {
      $(".navbar-collapse").collapse("hide");
    });
  }
  
  

  render() {
    return (
      <nav
        className="navbar navbar-b navbar-trans navbar-expand-md fixed-top"
        id="mainNav"
      >
        <div className="container">
          <a className="navbar-brand js-scroll" href="#page-top">
            <img
              src={this.state.logo}
              alt="logo"
              style={{ maxWidth: "100px" }}
            />
          </a>
          <button
            className="navbar-toggler collapsed"
            type="button"
            data-toggle="collapse"
            data-target="#navbarDefault"
            aria-controls="navbarDefault"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
          <div
            className="navbar-collapse collapse justify-content-end"
            id="navbarDefault"
          >
            <ul className="navbar-nav">
              {/* <li className="nav-item">
                <a className="nav-link js-scroll active" href="#home">
                  Home
                </a>
              </li> */}
              <li className="nav-item">
                <a className="nav-link js-scroll" href="#about">
                  About Us
                </a>
              </li>
              <li className="nav-item">
                {/* <a className="nav-link js-scroll" href="#services">
                  Services
                </a> */}
                <div class="dropdown">
                  <a class="nav-link js-scroll dropdown-toggle" data-toggle="dropdown" href="#service">Services
                  </a>
                    <ul class="dropdown-menu">
                      <li className="dropdown-submenu " tabindex="-1">
                        <a className="nav-link js-scroll" href="#itservices">IT Services</a>
                          <ul className="dropdown-menu">
                            <li><a className="nav-link js-scroll" tabindex="-1" href="#aimlservices">AI/ML Services</a></li>
                            <li><a className="nav-link js-scroll" tabindex="-1" href="#salesandservices">Sales & Sevices</a></li>
                          </ul>
                      </li>
                      <li><a className="nav-link js-scroll" href="#itconsulting">IT Consulting</a></li>
                      <li><a className="nav-link js-scroll" href="#salesandservices">Sales & Sevices</a></li>
                    </ul>
                </div>
                
                {/* <ul>
                    <div class="dropdown">
                      <div class="dropdown-content">
                        <ul>
                          <li>
                            <a className="nav-link js-scroll" href="#itservices">
                              IT Services
                            </a>
                          </li>
                          <li>
                            <a className="nav-link js-scroll" href="#itconsulting">
                                IT Consulting
                            </a>
                          </li>
                          <li>
                            <a className="nav-link js-scroll" href="#saleandservices">
                              Sales & Sevices
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                </ul> */}
              </li>
              <li className="nav-item">
                <a
                  className="nav-link js-scroll"
                  href="#technology">
                  Technology
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link js-scroll" href="/">
                  Insights
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/">
                  Careers
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link js-scroll" href="#contact">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}

export default Navbar;
